module.exports = __webpack_public_path__ + "img/c04_unitasabara_Normal_ua.f626ed3e.webp";